import { html, LitElement } from 'lit';
import { when } from 'lit/directives/when.js';
import { ifDefined } from 'lit/directives/if-defined.js';
import { customElement, property } from 'lit/decorators.js';
import { commonStyles } from '@styles/common';
import { buttonMaterial } from '@styles/buttonMaterial';

@customElement('submit-button-component')
export class SubmitButton extends LitElement {

  static styles = [
    commonStyles,
    buttonMaterial
  ]

  @property()
  btnText?: string;

  @property()
  additionalClasses = "";

  @property()
  disabled?: boolean;

  render() {
    return html`
    ${when(this.disabled, () => html`
      <svg class="spinner" viewBox="0 0 100 100" xmlns="http://www.w3.org/2000/svg">
        <circle cx="50" cy="50" r="36"/>
      </svg>
    `, () => html`
      <button
        id="submit-proposal"
        class="jr-button-material ${this.disabled ? 'jr-button--loading' : ''} ${this.additionalClasses}" 
        type="submit" 
        ?disabled=${ifDefined(this.disabled)}
        @click=${this.clickHandler}>
        ${this.btnText}
      </button>`)}
    `
  }

  private clickHandler() {
    const event = new CustomEvent('button-click-event');

    this.dispatchEvent(event);
  }
}